import React from "react";
import DefaultErlichPage from '../components/Form/DefaultErlichPage';


const CaesarErlichPage = () => {

const columns = [
  { id: 'mcbSerialNumber', label: 'mcbSerialNumber' , align: 'left'},
  { id: 'systemCustomerSerial', label: 'systemCustomerSerial', align: 'center'},
  { id: 'serial', label: 'serial', align: 'center'},
  { id: 'display', label: 'display', align: 'center'},
  { id: 'profile', label: 'profile', align: 'center'},
  { id: 'startPacketTime', label: 'startPacketTime', align: 'center'},
  { id: 'error', label: 'error', align: 'center'},
  { id: 'runningPacketTime', label: 'runningPacketTime', align: 'center'},
  { id: 'action', label: 'Download', align: 'center', action: true},
];

  return (<DefaultErlichPage
            title="Row Erlich"
            columns={columns}
            queryURL="/data/v1/caesar-erlich"
            downloadURL="/data/v1/caesar-erlich-file"
            />);
};

export default CaesarErlichPage;
